module.exports = __webpack_public_path__ + "img/search.59ee4259.svg";